export default "__VITE_ASSET__BkvpeA_r__"